module.exports = __webpack_public_path__ + "static/media/girl.9f480787.png";